import { Box, Button, Stack } from "@mui/material";
import { useFormState } from "../../hooks/use-form-state";
import {
  confirmPasswordValidator,
  passwordValidator,
} from "../../utils/validators";
import { PasswordInput } from "../../components/password-input";
import { useResetPassword } from "../../hooks/use-reset-password";
import { useScreenAlert } from "../../hooks/use-screen-alert";
import { useNavigate } from "react-router";
import { Views } from "../../utils/types";

const initialState = {
  password: "",
  confirmPassword: "",
};

export const ResetPasswordForm = ({
  resetKey,
  login,
}: {
  resetKey: string;
  login: string;
}) => {
  const { setError, setSuccess } = useScreenAlert();
  const { loading, resetPassword } = useResetPassword();
  const navigate = useNavigate();
  const { state, handleChange, errors, hasError, handleSubmit } = useFormState({
    initialState,
    onSubmit: async (formData) => {
      const result = await resetPassword(resetKey, login, formData.password);
      if (!result) {
        setError("Failed to reset password. The link may have expired — please request a new one.");
        return;
      }
      setSuccess("Password reset successfully!");
      navigate(Views.SIGN_IN, { replace: true });
    },
    validate: (formData) => {
      const errors: Record<string, string | undefined> = {};
      errors.password = passwordValidator(formData.password);
      errors.confirmPassword = confirmPasswordValidator(
        formData.password,
        formData.confirmPassword
      );
      return errors;
    },
  });

  return (
    <Box>
      <Stack spacing={2}>
        <PasswordInput
          value={state.password}
          onChange={handleChange("password")}
          label="New Password"
          name="password"
          error={errors.password}
          disabled={loading}
        />
        <PasswordInput
          value={state.confirmPassword}
          onChange={handleChange("confirmPassword")}
          label="Confirm Password"
          name="confirmPassword"
          error={errors.confirmPassword}
          disabled={loading}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={hasError || loading}
        >
          {loading ? "Resetting Password..." : "Reset Password"}
        </Button>
      </Stack>
    </Box>
  );
};
